import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "dt__section" }
const _hoisted_3 = {
  key: 0,
  class: "dt__section-header"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "dt__section-title" }, "Все разделы", -1 /* HOISTED */)
const _hoisted_5 = { class: "dt__section-header-search" }
const _hoisted_6 = { class: "dt__section-content" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slider_categories = _resolveComponent("slider-categories")!
  const _component_skeleton_section = _resolveComponent("skeleton-section")!
  const _component_category_search_component = _resolveComponent("category-search-component")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_open_data_view = _resolveComponent("open-data-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_slider_categories),
    _createElementVNode("div", _hoisted_2, [
      (this.loading)
        ? (_openBlock(), _createBlock(_component_skeleton_section, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (this.categories.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_category_search_component, {
                      categories: this.categories,
                      placeholder: 'Поиск по разделам'
                    }, null, 8 /* PROPS */, ["categories"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.categories, (category) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: category.id,
                  class: "dt__section-content-item"
                }, [
                  _createVNode(_component_router_link, {
                    to: category.getUrl(),
                    class: "dt__section-content-item-clickItem"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "dt__section-content-item-head",
                        style: _normalizeStyle({backgroundImage: 'url(' + category.image.url + ')'})
                      }, [
                        _createVNode(_component_router_link, {
                          to: category.getUrl(),
                          class: "dt__section-content-item-head-title"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(category.name.name), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                      ], 4 /* STYLE */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["dt__section-content-item-content", $options.checkBlock(category.id) ? 'content-visible' : ''])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.pages.slice(0, 5), (page) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        to: page.getUrl(),
                        class: "dt__section-content-item-content-item"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(page.name), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                    }), 256 /* UNKEYED_FRAGMENT */)),
                    (category.pages.length > 5)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: category.getUrl(),
                          class: "dt__section-content-item-content-more"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Показать больше (ещё " + _toDisplayString(category.pages.length - 5) + ") ", 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */),
                  _createElementVNode("div", {
                    onClick: ($event: any) => (this.toggleBlock(category)),
                    class: "dt__section-content-item-arrow"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["dt__section-content-item-arrow_arrow", $options.checkBlock(category.id) ? 'open' : ''])
                    }, null, 2 /* CLASS */)
                  ], 8 /* PROPS */, _hoisted_7)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    _createVNode(_component_open_data_view)
  ]))
}